<template>
  <!-- 招投标违法 -->
  <div>
    <block>
      <div id="illegalBidCount" style="position: relative;height: 0;overflow: hidden;top: -120px;"></div>
      <div class="table-list-title dis-bet-cen">
        <div>政府采购严重违法失信 <span style="color: #5D6FE9;">{{page.total}}</span></div>
      </div>
      <el-table
        border
        :data="TableData"
        :cell-style="cellStyle"
        :header-cell-style="headerColor"
        style="width: 100%;">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column v-for="(item,index) in tableHeader" :key="index" :label="item.label" :property="item.property" align="center">
          <template #default="scope">
            <el-button v-if="scope.column.property == 'handleImg'">预览</el-button>
            <el-button v-else-if="scope.column.property == 'handleDetails'">详情</el-button>
            <span v-else>{{scope.row[scope.column.property] || '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!fuzzyDataShow && !returnLimit"
          label="操作"
          width="80">
          <template #default="scope">
           <el-button type="text" @click="handleTo(scope.row)">详情</el-button>
          </template>
        </el-table-column>
        <template #empty style="width: 100%;">
          <gaussian-blur-empty-login @loginEmit="loginEmit" v-show="!islogin"></gaussian-blur-empty-login>
          <gaussian-blur-empty-vip @loginEmit="loginEmit" v-show="fuzzyDataShow && returnLimit"></gaussian-blur-empty-vip>
          <gaussian-blur-empty-vip @loginEmit="loginEmit" v-show="!fuzzyDataShow && returnLimit && TableData.length == 0"></gaussian-blur-empty-vip>
        </template>
      </el-table>
      <gaussian-blur-empty-vip @loginEmit="loginEmit" v-show="!fuzzyDataShow && returnLimit && TableData.length > 0"></gaussian-blur-empty-vip>
      <div class="table-page" v-show="!fuzzyDataShow && !returnLimit">
        <el-pagination
          background
          hide-on-single-page="true"
          :page-size="10"
          :pager-count="7"
          layout="prev, pager, next"
          v-model:currentPage="page.pageNum"
          @current-change="pageChange"
          :total="page.total">
        </el-pagination>
        <el-dialog title="政府采购严重违法详情" :append-to-body="appendtobody" v-model="dialogTableVisible">
            <el-descriptions class="margin-top"  :column="1" :size="size" border>
              <el-descriptions-item :span="1">
                <template #label>处罚日期</template>
                {{companyDetail.date || '-'}}
              </el-descriptions-item>
              <el-descriptions-item :span="1">
                <template #label>执法单位</template>
                {{companyDetail.organ || '-'}}
              </el-descriptions-item>
              <el-descriptions-item :span="1">
                <template #label>决定文书号</template>
                {{companyDetail.decision || '-'}}
              </el-descriptions-item>
              <el-descriptions-item :span="1">
                <template #label>处罚内容</template>
                {{companyDetail.content || '-'}}
              </el-descriptions-item>
              <el-descriptions-item :span="1">
                <template #label>处罚依据</template>
                {{companyDetail.reason || '-'}}
              </el-descriptions-item>
              <el-descriptions-item :span="1">
                <template #label>处罚结果</template>
                {{companyDetail.executegov || '-'}}
              </el-descriptions-item>
              <el-descriptions-item :span="1">
                <template #label>处罚结束日期</template>
                {{companyDetail.showTime || '-'}}
              </el-descriptions-item>
            </el-descriptions>
        </el-dialog>
      </div>
    </block>
  </div>
</template>

<script>
import { oldForwardBG } from '@/api/forward.js'
import GaussianBlurEmptyLogin from '@/components/gaussian-blur/gaussian-blur-empty-login'
import GaussianBlurEmptyVip from '@/components/gaussian-blur/gaussian-blur-empty-vip'
import { mapGetters } from 'vuex'
export default {
  setup (props, context) {
    function loginEmit () {
      context.emit('loginEmit', 'company')
    }
    return {
      loginEmit
    }
  },
  components: { GaussianBlurEmptyLogin, GaussianBlurEmptyVip },
  name: 'illegal-bid-count',
  props: { companyId: String, num: Number },
  data () {
    return {
      appendtobody: true,
      companyDetail: {},
      dialogTableVisible: false,
      page: {
        total: this.num ? this.num : 0,
        pageNum: 1
      },
      // 股东信息
      tableHeader: [{
        label: '处罚日期',
        property: 'date'
      }, {
        label: '处罚单位',
        property: 'organ'
      }, {
        label: '决定书文号',
        property: 'decision'
      }, {
        label: '处罚结果',
        property: 'content'
      }, {
        label: '处罚结束日期',
        property: 'date'
      }],
      TableData: [],
      islogin: false,
      returnLimit: false,
      fuzzyDataShow: false
    }
  },
  computed: {
    ...mapGetters([
      'vipData', // 会员数据
      'idToken',
      'userInfo'
    ]),
    vipLevelChange: function () {
      const vm = this
      if (vm.vipData && JSON.parse(vm.vipData)) {
        return JSON.parse(vm.vipData).vipLevel
      } else {
        return null
      }
    }
  },
  mounted () {
    if (this.idToken) {
      this.islogin = true
      this.initData()
    } else {
      this.islogin = false
    }
  },
  watch: {
    idToken: {
      handler (val, oldval) {
        if (val) {
          if (this.idToken) {
            this.islogin = true
            this.initData()
          } else {
            this.islogin = false
          }
        }
      }
    },
    vipLevelChange: function (newValue, oldValue) {
      if (this.idToken) {
        this.islogin = true
        this.initData()
      } else {
        this.islogin = false
      }
    }
  },
  methods: {
    handleTo (e) {
      this.dialogTableVisible = true
      this.companyDetail = e
    },
    // 表格设置样式
    headerColor: function ({ row, column, rowIndex, columnIndex }) {
      return 'background-color:#E8EBFC;color:#666666;font-size:14px;text-align:center'
    },
    cellStyle: function ({ row, column, rowIndex, columnIndex }) {
      return 'text-align:center'
    },
    pageChange (e) {
      this.page.pageNum = e
      this.initData()
    },
    initData: function () {
      const vm = this
      const data = {
        dateBackgroundUrl: '/CompanyAdministrativePenalty/getAdministrativePenaltyListSeventh',
        dateBackgroundRequestType: 'get',
        data: {
          companyId: vm.companyId,
          penaltyType: 3,
          pageNum: vm.page.pageNum,
          pageSize: 10
        }
      }
      oldForwardBG(data).then(result => {
        if (result.code === 0 || result.code === 97 || result.code === 98) {
          if (result.code === 97) {
            vm.returnLimit = true
            vm.fuzzyDataShow = false
          } else if (result.code === 98) {
            vm.returnLimit = true
            vm.fuzzyDataShow = true
          } else {
            vm.returnLimit = false
            vm.fuzzyDataShow = false
          }
          console.log(1123)
          console.log(result)
          const res = result.data.pageResult
          const arr = []
          vm.page.total = res.total
          res.list.forEach(item => {
            item.liandate = item.liandate ? item.liandate.substring(0, 10) : '-'
            item.publicdate = item.publicdate ? item.publicdate.substring(0, 10) : '-'
            arr.push(item)
          })
          vm.TableData = arr
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped="scoped" lang="less">
.table-list-title {
  padding: 18px 0;
  text-align: left;
  color: #333;
  font-weight: bold;
}
.table-page {
  text-align: right;
  margin-top: 10px;
}
/deep/ .el-table__empty-text {
  width: 100%;
}
</style>
